import React, { useEffect } from "react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { useMachine } from "@xstate/react";
import { createMachine } from "xstate";

import { actions } from "./actions";
import { MACHINE_CONFIG } from "./config";
import { services } from "./services";

export const triggerCyclone = React.createContext({});
export let triggerCycloneMachine: any;

const MODULE_NAME = "machines.triggerCyclone";
const log: any = LoggerModule?.getInstance();

export const useSMTriggerCyclone = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  triggerCycloneMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(triggerCycloneMachine);

  return {
    triggerCycloneMachine,
    triggerCycloneState: state,
    triggerCycloneSend: send,
  };
};
